import React, { useEffect, useState } from "react";
import BookingDetalisListSideNavigation from "../../components/Layouts/ReservationsCard/BookingDetalisListSideNavigation";
import ReservationCard from "../../components/Layouts/ReservationsCard/ReservationsCards";
import { t } from "i18next";
import { AppStandardButton } from "../../components/UI/AppButtons";
import { BookingApi } from "../../API/Apis/BookingApi";
import Typography from "@mui/material/Typography";
import CollapsibleNavbar from "../../components/Layouts/ReservedAreaDashboard/CollapseNavbar";
import { getParentOrigin, allowedOrigins } from "../../helpers/iframeSource";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import { Search } from "@mui/icons-material";

export default function MyReservedBookings() {
  const isSmallScreen = window.innerWidth <= 768;
  const [userId] = useState(localStorage.getItem("userID"));
  const [reservedArea, setReservedArea] = useState(false);
  const [loader] = useState(false);
  const [noOfBooking, setNoOfBookings] = useState(0);
  const [reservationList, setReservationList] = useState([]);
  const [resList, setResList] = useState([]);
  const [page, setPage] = React.useState(0);
  useEffect(() => {
    setReservedArea(!!userId);
  }, [userId]);
  const [loading, setLoading] = useState(false);

  const [rowsPerPage] = React.useState(6);
  const fetchReservations = async () => {
    if (isSmallScreen && loading) return;
    setLoading(true);
    try {
      const res = await BookingApi.getBookingDetailsbyUserId(
        userId,
        page * rowsPerPage,
        rowsPerPage
      );
      setNoOfBookings(res.data.total);
      setReservationList(res.data.reservationList);
      setResList(res.data.reservationList);
      if (!isSmallScreen) {
        return res.data.reservationList;
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching reservations:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchReservations();
  }, [page, rowsPerPage]);
  const handlePageChange = (_event, newPage) => {
    setPage(newPage);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = (isOpen) => {
    setIsDrawerOpen(isOpen);
  };

  const parentOrigin = getParentOrigin();
  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

  function requestParentResize() {
    window.parent.postMessage(
      {
        event_id: "iframeHeight",
        data: {
          iframeHeight: isSmallScreen ? 870 : 675,
        },
      },
      targetOrigin
    );
  }
  useEffect(() => {
    requestParentResize();
  }, []);
  const [searchInput, setSearchInput] = useState("");
  const [searchRes, setSearchRes] = useState("");
  const handleSearchRes = () => {
    setSearchRes(searchInput);
  };
  useEffect(() => {
    if (searchRes != null && searchRes != "") {
      const searchTerm = searchRes.trim().replace(/\s+/g, "").toLowerCase();
      console.log("searchTerm", searchTerm);
      const filteredRes = resList.filter((res) => {
        const prefix = res?.prefix?.toString().toLowerCase();
        const number = res?.number?.toString().toLowerCase();
        return (
          prefix.includes(searchTerm) ||
          number.includes(searchTerm) ||
          searchTerm.includes(prefix + number)
        );
      });
      setNoOfBookings(filteredRes.length);
      setReservationList(filteredRes);
    } else {
      setNoOfBookings(noOfBooking);
      setReservationList(reservationList);
    }
  }, [searchRes]);

  return (
    <div>
      <>
        <div
          style={{
            color: "white",
            display: "none",
          }}
        >
          <CollapsibleNavbar
            isDrawerOpen={isDrawerOpen}
            toggleDrawer={toggleDrawer}
          />
        </div>
      </>
      <div className="flex">
        {!isSmallScreen && (
          <div className="!w-780" style={{ width: "363px" }}>
            <BookingDetalisListSideNavigation />
          </div>
        )}
        <div className="w-full rounded-sm pt-12">
          {!isSmallScreen && (
            <div className="text-[#333] px-8 max-w-screen-xl m-auto">
              <div className={"flex justify-between"}>
                <p
                  className="text-[36px] font-medium leading-snug whitespace-nowrap"
                  style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}
                >
                  {t("Booking Details")}
                </p>
                <div className={"flex flex-row"}></div>
                <div className={"flex flex-row"}></div>
                <div className={"flex flex-row"}></div>
                <div
                  className="flex flex-wrap flex-row"
                  style={{
                    marginLeft: isSmallScreen ? "0px" : "35%",
                    fontFamily: "MBCorpoSTitle-Bold-Web-new",
                  }}
                ></div>
                {!isSmallScreen && (
                  <TextField
                    variant="outlined"
                    className="mr-4"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    placeholder={t("Search Reservation")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Search
                            onClick={handleSearchRes}
                            style={{
                              cursor: "pointer",
                              color: "#333",
                              height: "16px",
                            }}
                          />
                        </InputAdornment>
                      ),
                      style: {
                        height: "40px",
                        borderRadius: "10px",
                        paddingRight: "5px",
                      },
                    }}
                  />
                )}
                <AppStandardButton
                  href="/"
                  className={"flex ml-8"}
                  variant="contained"
                  style={{
                    width: isSmallScreen ? "100px" : "125px",
                    backgroundColor: "primary",
                    fontFamily: "MBCorpoSText-Bold-Web-new",
                  }}
                >
                  <span
                    className="normal-case"
                    style={{
                      fontFamily: "MBCorpoSText-Bold-Web-new",
                    }}
                  >
                    {t("Book Now")}
                  </span>
                </AppStandardButton>
              </div>
              <p
                className="text-[#838181] text-[16px]"
                style={{
                  fontFamily: "MBCorpoSText-CondLight-Web",
                }}
              >
                {t("Here is your next reserve bookings.")}
              </p>
            </div>
          )}
          {isSmallScreen && (
            <div
              className="text-[#333] px-8 max-w-screen-xl m-auto"
              style={{
                paddingLeft: "1rem",
                paddingRight: "1rem",
                paddingTop: "16px",
              }}
            >
              <div>
                <div className="flex items-center gap-4 flex-wrap">
                  <div>
                    <p
                      className="text-[24px] font-medium leading-snug whitespace-nowrap"
                      style={{ fontFamily: "MBCorpoAScreen1Cond-Regular-Web" }}
                    >
                      {t("Booking Details")}
                    </p>

                    <p
                      className="text-[#838181] text-[16px]"
                      style={{
                        fontFamily: "MBCorpoSText-CondLight-Web",
                        fontSize: "12px",
                      }}
                    >
                      {t("Here is your next reserve bookings.")}
                    </p>
                  </div>

                  <AppStandardButton
                    href="/"
                    className="flex-shrink-0 ml-auto"
                    variant="contained"
                    style={{
                      width: isSmallScreen ? "" : "125px",
                      backgroundColor: "primary",
                      fontFamily: "MBCorpoSText-Bold-Web-new",
                    }}
                  >
                    <span
                      className="normal-case"
                      style={{
                        fontFamily: "MBCorpoSText-Bold-Web-new",
                      }}
                    >
                      {t("Book Now")}
                    </span>
                  </AppStandardButton>
                </div>

                <div
                  className="text-[#333] max-w-screen-xl m-auto"
                  style={{
                    marginTop: "8px",
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    placeholder={t("Search")}
                    variant="outlined"
                    className="w-full mr-4"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <Search
                            style={{
                              cursor: "pointer",
                              color: "#333",
                              height: "16px",
                            }}
                            onClick={handleSearchRes}
                          />
                        </InputAdornment>
                      ),
                      style: {
                        height: "31px",
                        maxWidth: "600px",
                        borderRadius: "3px",
                        paddingRight: "15px",
                        backgroundColor: "#f7f7f7",
                        border: "1px solid #ddd",
                        fontSize: "16px",
                        color: "#666",
                      },
                    }}
                  />
                </div>
              </div>
              {/*<div*/}
              {/*  className="flex flex-row "*/}
              {/*  style={{*/}
              {/*    height: "26px",*/}
              {/*    marginTop: "7px",*/}
              {/*    zIndex: "10px",*/}
              {/*  }}*/}
              {/*></div>*/}
            </div>
          )}
          {loader ? (
            <Typography
              className="!text-center !text-3xl !flex !justify-center"
              style={{ fontFamily: " MBCorpoAScreen1Cond-Regular-Web" }}
            >
              Loading...
            </Typography>
          ) : (
            <div className="p-4">
              <ReservationCard
                reservationList={reservationList}
                noOfBooking={noOfBooking}
                handlePageChange={handlePageChange}
                loader={loader}
                rowsPerPage={6}
                page={page}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
